import { useQuery } from "@tanstack/react-query";
import { featureFlagService } from "@/services/breeze/FeatureFlagService";

interface UseFeatureFlagOptions {
  defaultValue?: boolean;
}

export function useFeatureFlag(
  flagName: string,
  options: UseFeatureFlagOptions = {},
) {
  const { defaultValue = false } = options;

  const {
    data: featureFlags,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["featureFlags"],
    queryFn: () => featureFlagService.getFeatureFlags(),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  if (isLoading || error) {
    return defaultValue;
  }

  const flag = featureFlags?.find((flag) => flag.name === flagName);
  return flag?.is_enabled ?? defaultValue;
}
